var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e5701e53ae05e7a197c4b0c60bd5fccf463ac31e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["appsmith@appsmith"]={id:"e5701e53ae05e7a197c4b0c60bd5fccf463ac31e"};
      